export default {"src":"/_next/static/media/voetbal.b48be9c7.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};